import { useEffect, useState } from 'react'
import { useAppDispatch, useAppSelector } from '../../../../lib/redux/hooks'
import '../../styles.scss'
import { SingleCheckbox } from '../../../../ui/molecules/SingleCheckbox'
import { InspectionVisitCreation, setIVCreationAnnualControlPlaneDetailId, setIVCreationAssignmentId, setIVCreationBioNotificationId, setIVCreationControlDetail, setIVCreationCustomerId, setIVCreationDocumentalControl, setIVCreationExpertSubject, setIVCreationExpirationDate, setIVCreationExpirationDateExtended, setIVCreationInAccompanyingSubject, setIVCreationInAccompanyingSubjectEntity, setIVCreationInLocoControl, setIVCreationInSupportSubject, setIVCreationInSupportSubjectEntity, setIVCreationLicenseeOperator, setIVCreationMode, setIVCreationPlannedSampling, setIVCreationRemoteVisit, setIVCreationSpecification, setIVCreationTraineeTechnician, setIVCreationType, setIVUpdateSqnpiControlActivities } from '../../slice'
import { IVSQNPIActivityEnum, productionTypeSQNPI } from '../../dataservice/dto'
import { SelectCustom } from '../../../../ui/molecules/select'
import { IVModeOptions, IVTypeOptions, optionsFormatter, OptionType, PACVisitingTypeOptions } from '../../../../utils'
import InputMultiSearch from '../../../../ui/molecules/input/InputMultiSearch'
import { GetAllPacDetails, GetPacDetailById, resetGetAllPACDetailsStatus, resetGetPACDetailByIdStatus } from '../../../gestioneControllo/pac/slice'
import { Calendar } from '../../../../ui/molecules/calendar'
import { InfoBox } from '../../../../ui/molecules/infoBox'
import TextArea from '../../../../ui/molecules/textArea'
import { GetAllNotification, resetGetAllNotificationStatus } from '../../../notifiche/slice'
import Input from '../../../../ui/molecules/input'
import Button from '../../../../ui/molecules/button'
import { getOptions } from '../../utils'
import { ServiceTypeNormEnum } from '../../../schedaCalcolo/dataService/dto'
import { format } from 'date-fns'

interface Props {
    close: () => void
}

export function InspectionVisitProdIntegrataAddPopup(props: Props) {
    const dispatch = useAppDispatch()
    const assignmentState = useAppSelector(state => state.assignment)
    const pacState = useAppSelector(state => state.pac)
    const notificationState = useAppSelector(state => state.notification)
    const [pacOptions, setPacOptions] = useState<OptionType[]>([])
    const [locoControlFlag, setLocoControlFlag] = useState<boolean>(false)
    const [documentalControlFlag, setDocumentalControlFlag] = useState<boolean>(false)
    const [remoteVisitFlag, setRemoteVisitFlag] = useState<boolean>(false)
    const [licenseeOperatorFlag, setLicenseeOperatorFlag] = useState<boolean>(false)
    const [notifications, setNotifications] = useState<OptionType[]>([])
    const [plannedSamplingFlag, setPlannedSamplingFlag] = useState<boolean>(false)
    const [produtionFlag, setProdutionFlag] = useState<boolean>(false)
    const [processingFlag, setProcessingFlag] = useState<boolean>(false)
    const [distributionFlag, setDistributionFlag] = useState<boolean>(false)
    const [organizationFlag, setOrganizationFlag] = useState<boolean>(false)

    useEffect(() => {
        dispatch(setIVCreationAssignmentId(assignmentState.assignmentIdToUpdate))
    }, [])

    useEffect(() => {
        if (assignmentState.inspectionVisitCreationRequest.customerId === null)
            return

        dispatch(GetAllPacDetails({
            itemsPerPage: 0,
            page: 0,
            customerId: assignmentState.inspectionVisitCreationRequest.customerId,
            searchForAssignment: true
        }))

        dispatch(GetAllNotification({
            itemsPerPage: 0,
            page: 0,
            customerId: assignmentState.inspectionVisitCreationRequest.customerId
        }))
    }, [assignmentState.inspectionVisitCreationRequest.customerId])

    useEffect(() => {
        if (pacState.getAllPACDetailsStatus === 'successfully' &&
            pacState.getAllPACDetailsResponse !== undefined
        ) {
            dispatch(resetGetAllPACDetailsStatus())
            const data = pacState.getAllPACDetailsResponse.data.map(pac => {
                return {
                    value: pac.id,
                    label: `PAC: ${pac.annualControlPlaneDTO.year} - Data fine: ${pac.annualControlPlaneDTO.endingDate} - Tipo visita: ${optionsFormatter(pac.visitType, PACVisitingTypeOptions)} - Prelievo: ${pac.sampling ? 'Sì' : 'No'}`
                } as OptionType
            })
            setPacOptions(data)
        }
    }, [pacState.getAllPACDetailsStatus])

    useEffect(() => {
        if (assignmentState.inspectionVisitCreationRequest.annualControlPlaneDetailId)
            dispatch(GetPacDetailById(assignmentState.inspectionVisitCreationRequest.annualControlPlaneDetailId))
    }, [assignmentState.inspectionVisitCreationRequest.annualControlPlaneDetailId])

    useEffect(() => {
        if (pacState.getPACDetailByIdStatus === 'successfully' &&
            pacState.getPACDetailByIdResponse !== undefined
        ) {
            dispatch(resetGetPACDetailByIdStatus())
            dispatch(setIVCreationControlDetail(pacState.getPACDetailByIdResponse?.specifications))
        }
    }, [pacState.getPACDetailByIdStatus])

    useEffect(() => {
        if (notificationState.getAllNotificationStatus === 'successfully' &&
            notificationState.getAllNotificationResponse
        ) {
            dispatch(resetGetAllNotificationStatus())
            const data = notificationState.getAllNotificationResponse.data.map(n => {
                return {
                    value: n.id,
                    label: `Notifica n.${n.identifier} del ${n.releaseDate}`
                } as OptionType
            })
            setNotifications(data)
        }
    }, [notificationState.getAllNotificationStatus])

    useEffect(() => {
        if (assignmentState.inspectionVisitCreationStatus === 'successfully') {
            props.close()
        }
    }, [assignmentState.inspectionVisitCreationStatus])

    return (
        <div>
            <div className="bg-brandPrimary-100 pr-5 pl-5 pt-4 pb-5" style={{ borderTopWidth: 1 }}>

                <div className="pb-3">
                    <div className="text-left assignment-text-content">
                        Seleziona cliente Produziuone Integrata
                    </div>
                    <InputMultiSearch
                        searchOne
                        onSelectAddHandler={(res) => dispatch(setIVCreationCustomerId(res[0]))}
                    />
                </div>

                <div className="pb-3" style={{ borderBottom: '1px solid #d9e6e8' }}>
                    <div className="text-left assignment-text-content">
                        Seleziona PAC per il cliente
                    </div>
                    <SelectCustom
                        disabled={pacOptions.length < 1}
                        placeholder='Seleziona PAC...'
                        options={pacOptions}
                        value={assignmentState.inspectionVisitCreationRequest.annualControlPlaneDetailId}
                        onChange={(value) => {
                            dispatch(setIVCreationAnnualControlPlaneDetailId(value))
                        }}
                    />
                    {
                        assignmentState.inspectionVisitCreationRequest.annualControlPlaneDetailId && (
                            <div className={`mt-3 fade-div ${assignmentState.inspectionVisitCreationRequest.annualControlPlaneDetailId !== undefined ? 'fade-in' : ''}`}>
                                <div className='pb-1 assignment-title'>
                                    Prima visita presso il cliente - Ultima visita effettuata da ispettore TURE SCANDURRA
                                </div>
                                <div className='assignment-title'>
                                    GIOVANNI PREVITERA - Settore: Reg. (UE) n.1/2025 (Agricoltura biologica)
                                </div>
                            </div>
                        )
                    }

                </div>

                <div className="pb-1 pt-3 text-left assignment-subtitle">
                    Tipo di Controllo
                </div>

                <div className="ml-1 pb-3" style={{ display: 'flex', gap: '24px', alignItems: 'center' }}>
                    <div style={{ display: 'flex', gap: '16px', alignItems: 'center' }}>
                        <div className='text-left assignment-text-content'>
                            Controllo in Loco
                        </div>
                        <SingleCheckbox
                            label=''
                            checked={locoControlFlag}
                            setChecked={(value) => {
                                dispatch(setIVCreationInLocoControl(value))
                                setLocoControlFlag(value)
                            }}
                        />
                    </div>

                    <div style={{ display: 'flex', gap: '16px', alignItems: 'center' }}>
                        <div className='text-left assignment-text-content'>
                            Controllo Documentale
                        </div>
                        <SingleCheckbox
                            label=''
                            checked={documentalControlFlag}
                            setChecked={(value) => {
                                dispatch(setIVCreationDocumentalControl(value))
                                setDocumentalControlFlag(value)
                            }}
                        />
                    </div>

                    <div style={{ display: 'flex', gap: '16px', alignItems: 'center' }}>
                        <div className='text-left assignment-text-content'>
                            Controllo da remoto
                        </div>
                        <SingleCheckbox
                            label=''
                            checked={remoteVisitFlag}
                            setChecked={(value) => {
                                dispatch(setIVCreationRemoteVisit(value))
                                setRemoteVisitFlag(value)
                            }}
                        />
                    </div>
                </div>
                <div className="pb-1 text-left assignment-subtitle">
                    Attività oggetto di controllo
                </div>
                <div className="ml-1 pb-3" style={{ display: 'flex', gap: '24px', alignItems: 'center', flexWrap: 'wrap', borderBottom: '1px solid #d9e6e8' }}>

                    <div style={{ display: 'flex', gap: '16px', alignItems: 'center' }}>
                        <div className='text-left assignment-text-content'>
                            Produzione
                        </div>
                        <SingleCheckbox
                            label=''
                            checked={produtionFlag}
                            setChecked={(value) => {
                                let newActTypes: IVSQNPIActivityEnum[] = [...assignmentState.inspectionVisitCreationRequest.sqnpiControlActivities]
                                if (value && !newActTypes.includes(IVSQNPIActivityEnum.PRODUZIONE)) {
                                    newActTypes.push(IVSQNPIActivityEnum.PRODUZIONE)
                                }
                                else if (!value && newActTypes.includes(IVSQNPIActivityEnum.PRODUZIONE)) {
                                    newActTypes = newActTypes.filter(a => a !== IVSQNPIActivityEnum.PRODUZIONE)
                                }
                                dispatch(setIVUpdateSqnpiControlActivities(newActTypes))
                                setProdutionFlag(value)
                            }}
                        />
                    </div>

                    <div style={{ display: 'flex', gap: '16px', alignItems: 'center' }}>
                        <div className='text-left assignment-text-content'>
                            Preparazione
                        </div>
                        <SingleCheckbox
                            label=''
                            checked={processingFlag}
                            setChecked={(value) => {
                                let newActTypes: IVSQNPIActivityEnum[] = [...assignmentState.inspectionVisitCreationRequest.sqnpiControlActivities]
                                if (value && !newActTypes.includes(IVSQNPIActivityEnum.PREPARAZIONE)) {
                                    newActTypes.push(IVSQNPIActivityEnum.PREPARAZIONE)
                                }
                                else if (!value && newActTypes.includes(IVSQNPIActivityEnum.PREPARAZIONE)) {
                                    newActTypes = newActTypes.filter(a => a !== IVSQNPIActivityEnum.PREPARAZIONE)
                                }
                                dispatch(setIVUpdateSqnpiControlActivities(newActTypes))
                                setProcessingFlag(value)
                            }}
                        />
                    </div>
                    <div style={{ display: 'flex', gap: '16px', alignItems: 'center' }}>
                        <div className='text-left assignment-text-content'>
                            Distribuzione
                        </div>
                        <SingleCheckbox
                            label=''
                            checked={distributionFlag}
                            setChecked={(value) => {
                                let newActTypes: IVSQNPIActivityEnum[] = [...assignmentState.inspectionVisitCreationRequest.sqnpiControlActivities]
                                if (value && !newActTypes.includes(IVSQNPIActivityEnum.DISTRIBUZIONE)) {
                                    newActTypes.push(IVSQNPIActivityEnum.DISTRIBUZIONE)
                                }
                                else if (!value && newActTypes.includes(IVSQNPIActivityEnum.DISTRIBUZIONE)) {
                                    newActTypes = newActTypes.filter(a => a !== IVSQNPIActivityEnum.DISTRIBUZIONE)
                                }
                                dispatch(setIVUpdateSqnpiControlActivities(newActTypes))
                                setDistributionFlag(value)
                            }}
                        />
                    </div>

                    <div style={{ display: 'flex', gap: '16px', alignItems: 'center' }}>
                        <div className='text-left assignment-text-content'>
                            Organizzazione
                        </div>
                        <SingleCheckbox
                            label=''
                            checked={organizationFlag}
                            setChecked={(value) => {
                                let newActTypes: IVSQNPIActivityEnum[] = [...assignmentState.inspectionVisitCreationRequest.sqnpiControlActivities]
                                if (value && !newActTypes.includes(IVSQNPIActivityEnum.ORGANIZZAZIONE)) {
                                    newActTypes.push(IVSQNPIActivityEnum.ORGANIZZAZIONE)
                                }
                                else if (!value && newActTypes.includes(IVSQNPIActivityEnum.ORGANIZZAZIONE)) {
                                    newActTypes = newActTypes.filter(a => a !== IVSQNPIActivityEnum.ORGANIZZAZIONE)
                                }
                                dispatch(setIVUpdateSqnpiControlActivities(newActTypes))
                                setOrganizationFlag(value)
                            }}
                        />
                    </div>

                </div>

                <div className='pb-3 pt-3' style={{ display: 'flex', gap: '24px', alignItems: 'center' }}>
                    <div style={{ flex: '0.5' }}>
                        <div className="text-left assignment-text-content">
                            Tipo visita
                        </div>
                        <SelectCustom
                            placeholder='Seleziona tipo...'
                            options={getOptions(ServiceTypeNormEnum.PRODUZIONE_INTEGRATA)}
                            value={assignmentState.inspectionVisitCreationRequest.type}
                            onChange={(value) => {
                                dispatch(setIVCreationType(value))
                            }}
                        />
                    </div>
                    <div style={{ flex: '0.5' }}>
                        <div className="text-left assignment-text-content">
                            Modalità
                        </div>
                        <SelectCustom
                            placeholder='Seleziona modalità...'
                            options={IVModeOptions}
                            value={assignmentState.inspectionVisitCreationRequest.mode}
                            onChange={(value) => {
                                dispatch(setIVCreationMode(value))
                            }}
                        />
                    </div>
                </div>

                <div className='pb-3' style={{ display: 'flex', gap: '24px', alignItems: 'center' }}>
                    <div style={{ flex: '0.5' }}>
                        <div className="text-left assignment-text-content">
                            Scadenza
                        </div>
                        <Calendar
                            selected={assignmentState.inspectionVisitCreationRequest.expirationDate}
                            onChange={(date) => dispatch(setIVCreationExpirationDate(format(new Date(date), 'yyyy-MM-dd')))}
                        />
                    </div>
                    <div style={{ flex: '0.5' }}>
                        <div className="text-left assignment-text-content">
                            Data Scadenza prorogata al
                        </div>
                        <Calendar
                            selected={assignmentState.inspectionVisitCreationRequest.expirationDateExtended}
                            onChange={(date) => dispatch(setIVCreationExpirationDateExtended(format(new Date(date), 'yyyy-MM-dd')))}
                        />
                    </div>
                </div>

                <div className='pb-3' style={{ display: 'flex', gap: '16px', alignItems: 'center' }}>
                    <div className='text-left assignment-text-content'>
                        Operatore Licenziatario
                    </div>
                    <SingleCheckbox
                        label=''
                        checked={licenseeOperatorFlag}
                        setChecked={(value) => {
                            dispatch(setIVCreationLicenseeOperator(value))
                            setLicenseeOperatorFlag(value)
                        }}
                    />
                </div>

                {/* <div className='pb-3'>
                    <InfoBox
                        title='Dettaglio Controllo Straordinario/Mirato'
                        color='green'
                        freeText={pacState.getPACDetailByIdResponse?.specifications ?
                            { title: null, label: pacState.getPACDetailByIdResponse?.specifications } : undefined
                        }
                    />
                </div> */}

                <div className='pb-3'>
                    <div className='text-left assignment-text-content'>
                        Specifiche
                    </div>
                    <TextArea
                        value={pacState.getPACDetailByIdResponse?.specifications}
                        onChangeText={(text) => dispatch(setIVCreationSpecification(text))}
                    />
                </div>

                <div className='pb-3' style={{ borderBottom: '1px solid #d9e6e8' }}>
                    <div className="text-left assignment-text-content">
                        Notifica oggetto di controllo
                    </div>
                    <SelectCustom
                        disabled={notifications.length < 1}
                        placeholder='Seleziona notifica...'
                        options={notifications}
                        value={assignmentState.inspectionVisitCreationRequest.bioNotificationId}
                        onChange={(value) => {
                            dispatch(setIVCreationBioNotificationId(value))
                        }}
                    />
                </div>

                <div className='pb-3 pt-3' style={{ display: 'flex', gap: '9px', alignItems: 'center' }}>
                    <div style={{ display: 'flex', gap: '16px', alignItems: 'center' }}>
                        <div className='text-left assignment-text-content'>
                            Prelievo Campioni
                        </div>
                        <SingleCheckbox
                            label=''
                            checked={plannedSamplingFlag}
                            setChecked={(value) => {
                                dispatch(setIVCreationPlannedSampling(value))
                                setPlannedSamplingFlag(value)
                            }}
                        />
                    </div>

                    <div style={{ flex: '1', display: 'flex', gap: '16px', alignItems: 'center' }}>
                        <div className='text-left assignment-text-content'>
                            Tipo Materiale
                        </div>
                        <div style={{ flex: '1' }}>
                            <Input
                                disabled={!plannedSamplingFlag}
                            />
                        </div>
                    </div>
                </div>

                <div className='pb-3' style={{ display: 'flex', gap: '24px', alignItems: 'center', borderBottom: '1px solid #d9e6e8' }}>
                    <div style={{ flex: '1', display: 'flex', gap: '6px', alignItems: 'center' }}>
                        <div className='text-left assignment-text-content'>
                            Busta 1
                        </div>
                        <div style={{ flex: '1' }}>
                            <Input

                            />
                        </div>
                    </div>

                    <div style={{ flex: '1', display: 'flex', gap: '16px', alignItems: 'center' }}>
                        <div className='text-left assignment-text-content'>
                            Busta 2
                        </div>
                        <div style={{ flex: '1' }}>
                            <Input

                            />
                        </div>
                    </div>

                    <div style={{ flex: '1', display: 'flex', gap: '16px', alignItems: 'center' }}>
                        <div className='text-left assignment-text-content'>
                            Busta 3
                        </div>
                        <div style={{ flex: '1' }}>
                            <Input

                            />
                        </div>
                    </div>

                    <div style={{ flex: '1', display: 'flex', gap: '16px', alignItems: 'center' }}>
                        <div className='text-left assignment-text-content'>
                            Busta 4
                        </div>
                        <div style={{ flex: '1' }}>
                            <Input

                            />
                        </div>
                    </div>
                </div>

                <div className='pb-3 pt-3' style={{ display: 'flex', gap: '24px', alignItems: 'center' }}>
                    <div style={{ flex: '0.5' }}>
                        <div className='text-left assignment-text-content'>
                            Soggetto in affiancamento
                        </div>
                        <Input
                            onChangeText={(text) => dispatch(setIVCreationInSupportSubject(text))}
                        />
                    </div>
                    <div style={{ flex: '0.5' }}>
                        <div className='text-left assignment-text-content'>
                            Ente
                        </div>
                        <Input
                            onChangeText={(text) => dispatch(setIVCreationInSupportSubjectEntity(text))}
                        />
                    </div>
                </div>

                <div className='pb-3 pt-3' style={{ display: 'flex', gap: '24px', alignItems: 'center' }}>
                    <div style={{ flex: '0.5' }}>
                        <div className='text-left assignment-text-content'>
                            Soggetto in accompagnamento
                        </div>
                        <Input
                            onChangeText={(text) => dispatch(setIVCreationInAccompanyingSubject(text))}
                        />
                    </div>
                    <div style={{ flex: '0.5' }}>
                        <div className='text-left assignment-text-content'>
                            Ente
                        </div>
                        <Input
                            onChangeText={(text) => dispatch(setIVCreationInAccompanyingSubjectEntity(text))}
                        />
                    </div>
                </div>

                <div className='pb-3 pt-3' style={{ display: 'flex', gap: '24px', alignItems: 'center' }}>
                    <div style={{ flex: '0.5' }}>
                        <div className='text-left assignment-text-content'>
                            Soggetto esperto
                        </div>
                        <Input
                            onChangeText={(text) => dispatch(setIVCreationExpertSubject(text))}
                        />
                    </div>
                    <div style={{ flex: '0.5' }}>
                        <div className='text-left assignment-text-content'>
                            Tecnico Tirocinante
                        </div>
                        <Input
                            onChangeText={(text) => dispatch(setIVCreationTraineeTechnician(text))}
                        />
                    </div>
                </div>
            </div>

            <div style={{ display: 'flex', justifyContent: 'flex-end', padding: 15, paddingRight: 15 }}>
                <Button
                    size="md"
                    variant="outline"
                    iconPosition="off"
                    label="Annulla"
                    color="dimgrey"
                    onClick={() => {
                        props.close();
                    }}
                />
                <div className="pl-2">
                    <Button
                        size="md"
                        variant="solid"
                        iconPosition="off"
                        label="Salva"
                        color="orange"
                        onClick={() => dispatch(InspectionVisitCreation(assignmentState.inspectionVisitCreationRequest))}
                    />
                </div>
            </div>
        </div>
    )
}